import { Box, TextField, BaseTextFieldProps } from '@mui/material'
import React, { forwardRef } from 'react'
import { boxStyle, textFieldStyle } from './HeaderSearchTextField.styles'

interface SearchTextFieldProps extends BaseTextFieldProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const HeaderSearchTextField = forwardRef<HTMLInputElement, SearchTextFieldProps>(({
  value,
  onChange,
  placeholder,
  ...props
}, ref) => {
  return (
    <Box sx={boxStyle}>
      <TextField
        ref={ref}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        sx={textFieldStyle}
        size={'small'}
        {...props}
      />
    </Box>
  )
})

HeaderSearchTextField.displayName = 'HeaderSearchTextField'
